<template>
  <div class="container">
    <div class="row">
      <div class="col align-self-center text-center ">
        <div v-if="!error">
          <square-loader />
          Connexion à Lettre Compte Triple<br />
          Passez un bon moment !
        </div>
        <div v-if="error" class="error">
          Une erreur est survenue, impossible de se connecter<br />
          <router-link to="/">Retour</router-link><br /><br /><br />
          <div class="text-left">
           Si l'erreur persiste, merci de copier-coller le contenu ci-dessous
           et de l'envoyer à sylvain.gourio@lettrecomptetriple.fr :<br />
           Détail de l'erreur<br />
           <code>
          {{error}}
          </code>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SquareLoader from './SquareLoader';
import iam from '../iam';

export default {
  name: 'Callback',
  components: { SquareLoader },
  data() {
    return {
      error: undefined,
    };
  },
  created() {
    const authorizationCode = this.$route.fullPath.match(/(?:code)=([^&]+)/)[1];
    iam.tokenCognito(authorizationCode)
      .then(() => this.$http.get(`${process.env.LCT_API_URL}/users/me`))
      .then(response => response.data)
      .then((user) => {
        if (user.username) {
          iam.setConnectedUser(user);
          this.$router.push('/lobby');
        } else {
          this.$router.push('/username');
        }
      })
      .catch((err) => {
        this.error = err;
        iam.logout();
      });
  },
};
</script>

<style scoped>
div.row {
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/Callback.vue